var map = {
	"./hosermage_8_bit_splash_screen_for_fortune_cookie_cafe_app_16c959c8-f5f6-498f-b5a2-67cb1117b8bb_0-800.jpg": 3205,
	"./hosermage_8_bit_splash_screen_for_fortune_cookie_cafe_app_1a72c9b4-d05a-472f-8216-9d540ddd08d8_0-800.jpg": 4314,
	"./hosermage_8_bit_splash_screen_for_fortune_cookie_cafe_app_1a72c9b4-d05a-472f-8216-9d540ddd08d8_1-800.jpg": 8827,
	"./hosermage_8_bit_splash_screen_for_fortune_cookie_cafe_app_1a72c9b4-d05a-472f-8216-9d540ddd08d8_2-800.jpg": 8972,
	"./hosermage_8_bit_splash_screen_for_fortune_cookie_cafe_app_1a72c9b4-d05a-472f-8216-9d540ddd08d8_3-800.jpg": 853,
	"./hosermage_fortune_cookie_cafe_7c4cef7e-487a-4f2d-b2c1-acb83f18bd3d_1-800.jpg": 1505,
	"./hosermage_fortune_cookie_cafe_7c4cef7e-487a-4f2d-b2c1-acb83f18bd3d_2-800.jpg": 5654,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama._Pixel_58931803-0d6f-45e7-95c3-035be25dbff8_0-800.jpg": 6989,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama._Pixel_58931803-0d6f-45e7-95c3-035be25dbff8_1-800.jpg": 5124,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama._Pixel_58931803-0d6f-45e7-95c3-035be25dbff8_2-800.jpg": 9859,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama._Pixel_58931803-0d6f-45e7-95c3-035be25dbff8_3-800.jpg": 8050,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama._Pixelat_a72b3069-f964-48e9-856e-86e82b98a381-800.jpg": 2979,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_0e999b81-b02b-4b0e-864a-5d7dcd648170-800.jpg": 2603,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_10a5bd90-e65c-4e6c-9bee-c67521a77a19-800.jpg": 4573,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_1ed29727-6760-44f0-9717-da32db832442-800.jpg": 6780,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_477005df-15cd-41a3-bf37-93addb60cf44_0-800.jpg": 335,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_477005df-15cd-41a3-bf37-93addb60cf44_1-800.jpg": 862,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_477005df-15cd-41a3-bf37-93addb60cf44_2-800.jpg": 3337,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_477005df-15cd-41a3-bf37-93addb60cf44_3-800.jpg": 2368,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_664f6def-de85-4ecb-91e6-bc6050cb314c-800.jpg": 5631,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_77fe4336-72c6-4cb9-9172-ff121b6bcc8c_0-800.jpg": 3299,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_77fe4336-72c6-4cb9-9172-ff121b6bcc8c_1-800.jpg": 7426,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_77fe4336-72c6-4cb9-9172-ff121b6bcc8c_2-800.jpg": 5117,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_77fe4336-72c6-4cb9-9172-ff121b6bcc8c_3-800.jpg": 4836,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_785db534-be47-4766-a70f-d684214f3c70-800.jpg": 4968,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_99acc639-6e86-460a-a7b5-306b16608565-800.jpg": 5701,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_bfff1ea9-3a6c-4f30-bf0e-49a282ddc3aa_0-800.jpg": 5565,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_bfff1ea9-3a6c-4f30-bf0e-49a282ddc3aa_1-800.jpg": 1268,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_bfff1ea9-3a6c-4f30-bf0e-49a282ddc3aa_2-800.jpg": 9363,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_bfff1ea9-3a6c-4f30-bf0e-49a282ddc3aa_3-800.jpg": 6066,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_c466a888-8e72-46d3-a488-60052db62566-800.jpg": 4311,
	"./hosermage_fortune_cookie_cafe_in_the_style_of_gudetama_c46fb327-aa81-49fa-9a47-6bfafdde3de2-800.jpg": 7876,
	"./hosermage_gudetama_as_a_fortune_cookie_5e1899d3-ce03-4485-bb77-ddd2273d3116_0-800.jpg": 7086,
	"./hosermage_gudetama_as_a_fortune_cookie_5e1899d3-ce03-4485-bb77-ddd2273d3116_1-800.jpg": 9231,
	"./hosermage_gudetama_as_a_fortune_cookie_5e1899d3-ce03-4485-bb77-ddd2273d3116_2-800.jpg": 464,
	"./hosermage_gudetama_as_a_fortune_cookie_5e1899d3-ce03-4485-bb77-ddd2273d3116_3-800.jpg": 329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9291;